import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ContentNav, { ContentNavLink } from "@webcore/components/domain/content-site/core/ContentNav";
import ContentFooter, { ContentFooterLink } from "@webcore/components/domain/content-site/core/ContentFooter";

export type NavLinkItem = ContentNavLink;

export interface ContentLayoutProps {
  brandName?: string;
  navLinks?: NavLinkItem[];
  showSignInButtons?: boolean;
  signUpEnabled?: boolean;
  footerItems?: ContentFooterLink[];
}

const ContentLayout: React.FC<ContentLayoutProps> = ({
  navLinks = [],
  showSignInButtons = true,
  signUpEnabled = false,
  footerItems = [
    { label: "Terms of Service", to: "/terms-of-service" },
    { label: "Privacy", to: "/privacy" },
  ],
}) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  return (
    <div className="content-site">
      <ContentNav
        navLinks={navLinks}
        showSignInButtons={showSignInButtons}
        signUpEnabled={signUpEnabled}
      />
      <main className="cs-main">
        <Outlet />
      </main>
      <ContentFooter resources={footerItems} />
    </div>
  );
};

export default ContentLayout;
